var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconCall = function IconCall(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.466 21.406l-6.183-8.831 3.136-4.52L7.779 0l-.677.183a8.287 8.287 0 00-2.595 1.226C1.845 3.273.661 6.169 1.083 9.786c.402 3.442 2.218 7.489 5.398 12.03 3.18 4.543 6.363 7.634 9.46 9.188 1.516.762 3.004 1.142 4.432 1.142 1.636 0 3.19-.5 4.61-1.494a8.281 8.281 0 002.04-2.02l.402-.573-5.639-8.054-5.32 1.4zm7.37 7.607c-2.05 1.436-4.404 1.506-6.998.204-2.798-1.404-5.73-4.28-8.718-8.547-2.989-4.267-4.688-8.008-5.05-11.116-.337-2.881.533-5.07 2.584-6.506a6.475 6.475 0 011.316-.716l4.012 5.728-3.137 4.52 7.782 11.115 5.32-1.401 4.012 5.728a6.501 6.501 0 01-1.122.99z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.011 14.648a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM22.511 16.148a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM27.011 14.648a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    fill: "currentColor"
  }));
};

IconCall.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconCall;
//# sourceMappingURL=IconCall.js.map